module.exports = __webpack_public_path__ + "static/media/miles-complete.9e585804.svg";